<template>
  <div class="app-control-right-cr" v-loading="loaded">
    <div class="acr-title">
      <h1>课程分类管理</h1>
      <el-button class="acr-title-add-button" type="primary" v-on:click="addClassification">
        添加分类
      </el-button>
    </div>
    <div class="acr-main">
      <el-table :data="classificationTableData" max-height="775px" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="330"></el-table-column>
        <el-table-column prop="name" label="分类名" width="150"></el-table-column>
        <el-table-column prop="trackTime" label="最后修改日期" min-width="200"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEditClassification(scope.row.id,scope.row.name)">
              编辑
            </el-button>
            <el-button type="text" size="small" @click="deleteClassification(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <EditClassificationDialog ref="EditClassificationDialog"></EditClassificationDialog>
  </div>
</template>

<script>

import AxiosBase from "@/components/axiosBase";
import EditClassificationDialog
  from "@/views/control/components/curriculum/CurriculumClassificationControl/EditClassificationDialog";
import util from "@/components/util";

export default {
  name: "CurriculumClassificationControl",
  components: {
    EditClassificationDialog
  },
  data() {
    return {
      classificationTableData: [],
      loaded: true
    }
  },
  beforeMount() {
    this.getClassificationData();
  },
  methods: {
    getClassificationData() {
      this.loaded = true;
      AxiosBase.axiosGet("/curriculum-ad/get-classification").then(response => {
        if (response !== 0) {
          response.data.forEach(jsonObject => {
            jsonObject.trackTime = util.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(jsonObject.trackTime))
          });
          this.classificationTableData = response.data;
          this.loaded = false;
        }
      })
    },
    addClassification() {
      this.$prompt('请输入新分类名', '添加课程分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{2,5}$/,
        inputErrorMessage: '课程分类名不符合标准,长度[2-5]'
      }).then(({value}) => {
        AxiosBase.axiosPut("/curriculum-ad/add-classification", {
          classificationName: value
        }).then(response => {
          if (response !== 0) {
            this.getClassificationData();
            this.$message({
              type: 'success',
              message: '添加分类成功'
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '操作取消'
        });
      });
    },
    openEditClassification(classificationId, classificationName) {
      this.$refs.EditClassificationDialog.bufferId = classificationId;
      this.$refs.EditClassificationDialog.bufferName = classificationName;
      this.$refs.EditClassificationDialog.changeClassificationNameForm.id = classificationId;
      this.$refs.EditClassificationDialog.changeClassificationNameForm.name = classificationName;
      this.$refs.EditClassificationDialog.dialogFormVisible = true;
    },
    deleteClassification(classificationId) {
      this.$confirm('此操作将永久删除该分类, 是否继续?', '删除分类', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        AxiosBase.axiosDelete("/curriculum-ad/del-classification", {
          params: {
            id: classificationId
          }
        }).then(response => {
          if (response !== 0) {
            this.getClassificationData();
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
        })
      })
    }
  }
}
</script>

